import React, { useState, useEffect, useContext } from "react";

import "./summary.css"
import FadeIn from 'react-fade-in';
import ReactScrollableList from 'react-scrollable-list';
import { Link } from 'react-router-dom';
import { ScrollView } from 'react-native';
import AuthService from "../services/auth.service";
import { Context } from '../context';

const topResultsNum = 50;

const SummaryPage = () => {

  const { state, dispatch } = useContext(Context);
  const [rankResults, setRankResults] = useState([]);
  const [scoreResults, setScoreResults] = useState([]);

  useEffect(() => {
    // if local storage can find the user information, try login
    const user = JSON.parse(localStorage.getItem("loggedInUser"));

    dispatch({
      type: "LOGIN",
      payload: {
        user: user,
        token: user ? user.token : ""
      }
    });

    AuthService.gameplay("getSummary",null,state)
      .then(async (res) => {

        if ('rankResults' in res.data) {
          setRankResults(res.data['rankResults']);
        }
        if ('scoreResults' in res.data) {
          setScoreResults(res.data['scoreResults']);
        }
      })
      .catch((err) => {
        console.error('err: failed summary fetch', err);
      });

  }, []);

  const showCorrectWrong = (a) => { return a == 0 ? "Wrong" : "Correct" }

  const genHorLine = (key) => { return <hr key={key} style={{ textAlign: 'center', marginTop: '3px',marginBottom: '3px' }}></hr>; }

  const calTotalScore = () => {
    let totalScore = 0;
    scoreResults.forEach(elem => { totalScore += elem[2] })
    return totalScore;
  }

  const genResults = () => {

    const ret = [];
    scoreResults.forEach((elem, index) => {

      ret.push(
        <FadeIn key={`key${index}`}>
          <em className={"score"}>
            {showCorrectWrong(elem[0])}&nbsp;&nbsp;&nbsp;{elem[1] + 's'}&nbsp;&nbsp;&nbsp;{elem[2]}
          </em>
        </FadeIn>
      );
      ret.push(genHorLine(`line${index}`));
    });

    ret.push(
      <FadeIn key={`key${ret.length}`}>
        <div className={"total-score"}>Total&nbsp;&nbsp;&nbsp;{calTotalScore()}</div>
      </FadeIn>
    )
    return ret;
  }

  const genRanking = () => {
    const ret = [];
    rankResults.forEach((elem, index) => {

      ret.push({
        id: `id${index}`,
        content: <div key={`rank${index}`} style={{ color: (index < 3) ? 'red' : 'black', fontWeight: (index < 3) ? 'bold' : 'normal', width: 'auto' }}>{`${index + 1}.`}&nbsp;&nbsp;&nbsp;{elem[0]}&nbsp;&nbsp;&nbsp;{elem[1]}</div>
      });
    });

    const ranking = <ReactScrollableList
      listItems={[...ret]} maxItemsToRender={topResultsNum} style={{ color: '#333' }}
    />;

    return <ScrollView className="bg-table-view" style={{ height: "22vh", width: "100%", marginLeft: "auto", marginRight: "auto", marginTop: "3vh" }} persistentScrollbar={true}>{ranking}</ScrollView>;
  }


  return (
    <div className="summary-page" style={{display:"inline-block",textAlign:"center",width:"auto",margin:"0"}}>
      <header className="summary-title">Game Results</header>
      {genResults()}
      <div style={{ height: '3vh' }}></div>
      {genRanking()}
      <div className="button-div">
        <Link to="/gameplay">
          <button className="restart-button">
            Restart
          </button>
        </Link>
        <Link to="/">
          <button className="home-button">
            HOME
          </button>
        </Link>
      </div>
    </div>
  );
}

export default SummaryPage;